import { BaseHTMLForm } from "mixs/base/form_html_mixin";
import { VALID_USER }   from "apps/action_types";
import { validations }  from "apps/actions/validations";
import { save, get }    from "apps/actions/common";
import { api } from "apps/api";
import serializeJSON    from 'utilities/serialize_json';
class Form extends BaseHTMLForm {
  validFunction = null;
  submitFunction = save;
}
riot.mixin('forms.orders.checking_orders_csv', Form as riot.TagMixin)
